import { useContext, createContext } from 'react';

const PermissionsContext = createContext(null);

export function usePermissions() {
    const context = useContext(PermissionsContext);
    
    if (!context) {
        throw new Error('usePermissions must be used within ModuleGuard');
    }
    return context;
}

export const PermissionsProvider = PermissionsContext.Provider;